import { validateCCExp, requiredValidation } from 'ggApp/modules/form';

const fieldValidationErrors = {
    cardholderName: (value) => requiredValidation(value) || null,
    cardExpiration: (value) => validateCCExp({ exp: value }) || null,
    cardNumber: (isValid) => (isValid ? null : 'FORM_VALIDATION_ERROR_INVALID_CC_NUMBER'),
    cardCVV: (isValid) => (isValid ? null : 'FORM_VALIDATION_ERROR_INVALID_CVC'),
};

export const defaultErrorState = {
    cardholderName: null,
    cardExpiration: null,
    cardNumber: null,
    cardCVV: null,
};

const pickDataForFieldValidator = (fieldName, formState) => {
    let fieldData;
    // eslint-disable-next-line default-case
    switch (fieldName) {
        case 'cardholderName':
        case 'cardExpiration':
            fieldData = formState[fieldName];
            break;
        case 'cardNumber':
            fieldData = formState.cardData.validNumber;
            break;
        case 'cardCVV':
            fieldData = formState.cardData.validCvv;
            break;
    }

    return fieldData;
};

export const validateFormField = (fieldName, formState) => {
    const fieldValidatorFunction = fieldValidationErrors[fieldName];
    return fieldValidatorFunction(pickDataForFieldValidator(fieldName, formState));
};

export const validateForm = (formState) => ({
    cardholderName: validateFormField('cardholderName', formState),
    cardExpiration: validateFormField('cardExpiration', formState),
    cardNumber: validateFormField('cardNumber', formState),
    cardCVV: validateFormField('cardCVV', formState),
});

export const isFormValid = (formState) => {
    const localErrorState = validateForm(formState);
    const fieldKeys = Object.keys(localErrorState);
    // form error object defined such as
    // a field is either 'null' or contains an error TK
    const hasInvalidFields = fieldKeys.some((key) => Boolean(localErrorState[key]));
    // return 'true' if form is valid
    return !hasInvalidFields;
};
